import { Box, CircularProgress, Typography } from '@mui/material';
import { useMemo } from 'react';

function LoadingOverlay({
    loading,
    percentage,
    disableShrink = false,
}: {
    loading: boolean;
    percentage: number;
    disableShrink?: boolean;
}) {
    const percentString = useMemo(() => {
        return Math.round(percentage) + '%';
    }, [percentage]);

    return (
        <>
            {loading && (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        flex: 1,
                        padding: 8,
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: (theme) => theme.zIndex.modal + 1,
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        top: 50,
                        left: 0,
                    }}
                >
                    <CircularProgress
                        size={80}
                        sx={{ color: 'secondary' }}
                        variant="indeterminate"
                        disableShrink={disableShrink}
                    />
                    <Typography sx={{ position: 'absolute', fontWeight: '500', fontSize: '1.5em' }}>
                        {percentString}
                    </Typography>
                </Box>
            )}
        </>
    );
}

export default LoadingOverlay;
